import { render, staticRenderFns } from "./SupportData.vue?vue&type=template&id=82ee4f50&scoped=true&"
import script from "./SupportData.vue?vue&type=script&lang=js&"
export * from "./SupportData.vue?vue&type=script&lang=js&"
import style0 from "./SupportData.vue?vue&type=style&index=0&id=82ee4f50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ee4f50",
  null
  
)

export default component.exports